import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CbDocumentsModule } from '@app/shared/components/documents/documents.module';
import { CbWaitForModule } from '@app/shared/directives/wait-for/wait-for.module';
import { IDocumentSelectionChangedEvent } from '@app/logic/documents';
import { ILotMappedItem } from '@app/logic/lots';
import { LotPermissions } from '@app/core/permissions';
import { LotTypeEnumId, SYSTEM_AREA_ENUM } from '@classictechsolutions/hubapi-transpiled-enums';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'cb-lot-migrator-document-selector',
    standalone: true,
    imports: [
        CbDocumentsModule,
        CbWaitForModule,
        MatStepperModule,
        MatIconModule,
        MatTooltipModule
    ],
    templateUrl: './lot-migrator-document-selector.component.html',
    styleUrls: ['./lot-migrator-document-selector.component.scss']
})
export class LotMigratorDocumentSelectorComponent {
    @Input() public lotMappedItems: ILotMappedItem[] = [];
    @Input() public lotType: LotTypeEnumId;
    @Input() public lotPermissions: LotPermissions;
    @Input() public systemArea = SYSTEM_AREA_ENUM.Lot;
    @Output() public selectionUpdated = new EventEmitter<IDocumentSelectionChangedEvent>();
    public selectedDocumentNamesByLotId: Record<number, string[]> = {};
    public readonly migrateLotsWizardDocumentUri = 'migratelotswizarddocuments';

    public getStepLabel(lotMappedItem: ILotMappedItem): string {
        return `${lotMappedItem?.jobNumber} (Lot ${lotMappedItem?.lotNumber})`;
    }

    public getSelectedDocumentsTooltip(lotId: number): string {
        const selectedNames = this.selectedDocumentNamesByLotId[lotId] ?? [];
        if (!selectedNames.length) {
            return 'No documents selected';
        }

        return selectedNames.join('\n');
    }

    public handleLotDocumentSelectionUpdated(
        lotMappedItem: ILotMappedItem,
        selectionEvent: IDocumentSelectionChangedEvent
    ): void {
        const selectedNames = (selectionEvent?.selectedDocuments).map(
            x => x?.document?.name ?? x?.documentType?.label
        );

        this.selectedDocumentNamesByLotId = {
            ...this.selectedDocumentNamesByLotId,
            [lotMappedItem.id]: selectedNames
        };

        this.selectionUpdated.emit(selectionEvent);
    }
}
